export default __webpack_public_path__ + "static/media/SendButton.ab3ac621.svg";